import * as React from 'react';

type CompactNumberType = {
    number: number;
    className?: string;
    fractionDigits?: number;
    suffix?: string;
};

const CompactNumber = (props: CompactNumberType) => {
    const formatter = Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: props.fractionDigits || 2,
        maximumFractionDigits: props.fractionDigits || 2,
    });

    return (
        <span className={props.className}>
            {formatter.format(props.number)}
            {props.suffix}
        </span>
    );
};

export default CompactNumber;
